import React, { useEffect, useMemo } from "react";
import { Modal } from "./Modal";
import { Stack, Typography, useTheme } from "@mui/material";
import { Button } from "components/button";
import { addMixpanelEvent } from "utilz/helpers";
import { useGlobalStore } from "controller";

export const TrialExtendModal = () => {
  const MODAL_KEY = "trialExtensionRequested";
  const mspId = useGlobalStore((state) => state.mspId);
  const [isModalOpen, setIsModalOpen] = React.useState(true);
  const [modalType, setModalType] = React.useState<"main" | "extend">("main");

  useEffect(() => {
    const modalStatus = localStorage.getItem(MODAL_KEY);
    if (modalStatus === "true") {
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  }, []);

  const getTitleContent = useMemo(
    () =>
      modalType === "main"
        ? "Your DeskDay Trial Has Ended"
        : "Trial Extension Request Sent",
    [modalType],
  );

  const handleExtendClick = () => {
    setModalType("extend");
    localStorage.setItem(MODAL_KEY, "true");
    addMixpanelEvent({
      event: "trial_extend_requested",
      data: {
        mspId: mspId,
      },
    });
  };
  return (
    <Modal
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      maxWidth="xs"
      paperStyles={{
        borderRadius: "8px",
      }}
      headerStyles={{ p: "14px 24px" }}
      customWidth="392px"
      title={getTitleContent}
      footer={<></>}
    >
      {modalType === "main" ? (
        <MainContent
          onClose={() => setIsModalOpen(false)}
          onExtend={() => handleExtendClick()}
        />
      ) : (
        <TrialExtendContent />
      )}
    </Modal>
  );
};

const MainContent = ({
  onClose,
  onExtend,
}: {
  onClose: () => void;
  onExtend: () => void;
}) => {
  const theme = useTheme();
  return (
    <Stack sx={{ p: "0px 24px 24px 24px", gap: "16px" }}>
      <Typography variant="body-small" color={theme.palette.lightBg.low}>
        We hope you made the most of your 14-day trial—let’s keep the momentum
        going!
      </Typography>
      <Button sx={{ mt: "8px" }} onClick={onClose}>
        Buy Now
      </Button>
      {/* <Button variant="secondary" onClick={onExtend}>
        Extend Trial
      </Button> */}
      <Button
        variant="ghost"
        onClick={() => {
          try {
            window.open(
              "https://meetings.hubspot.com/jobin-johny/deskday-demo-meet",
              "_blank",
            );
          } catch (error) {
            console.log(error);
          }
        }}
      >
        Request a Call
      </Button>
    </Stack>
  );
};

const TrialExtendContent = () => {
  const theme = useTheme();
  return (
    <Stack sx={{ p: "0px 24px 24px 24px", gap: "16px" }}>
      <Typography variant="body-small" color={theme.palette.lightBg.low}>
        Thank you! We have received your request and our Product Specialist will
        reach out shortly to confirm your trial extension.
      </Typography>
      <Button
        sx={{ mt: "8px" }}
        variant="ghost"
        onClick={() => {
          try {
            // @ts-ignore
            window.Intercom("show");
          } catch (error) {
            console.log(error);
          }
        }}
      >
        Need more help?
      </Button>
    </Stack>
  );
};
